export const timeLastToString = (timeLast: number): string => {
  if (timeLast < 10) {
    return `0${timeLast}`;
  } else {
    return `${timeLast}`;
  }
};
